export default __webpack_public_path__ + "static/media/logoPython.f95d0b5a.png";